module.exports = __webpack_public_path__ + "static/media/image5.b8cfe6bb.jpg";